"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DeserializeCache = exports.jsonStringify = void 0;
function jsonStringify(json) {
    var stringified;
    try {
        stringified = JSON.stringify(json);
    }
    catch (e) {
        stringified = '';
        console.warn(e);
    }
    return stringified;
}
exports.jsonStringify = jsonStringify;
var DeserializeCache = /** @class */ (function () {
    function DeserializeCache() {
        this.cachedModels = {};
    }
    DeserializeCache.prototype.getCachedModel = function (data, resourceIdObject) {
        var entityKey = this.createCacheKey(data, resourceIdObject);
        return this.cachedModels[entityKey] || null;
    };
    DeserializeCache.prototype.handleModel = function (model, data, resourceIdObject) {
        var entityKey = this.createCacheKey(data, resourceIdObject);
        var dataWithPayload = data.attributes || data.relationships;
        if (entityKey && dataWithPayload) {
            this.cachedModels[entityKey] = model;
        }
    };
    DeserializeCache.prototype.createCacheKey = function (data, resourceIdObject) {
        // resourceIdObject.meta sets to model in simplePropertyMappers.ts, so it should be used here too
        // cache in this case probably will be redundant
        if (!data.id || !data.type || resourceIdObject.meta) {
            return;
        }
        var resourcePart = resourceIdObject.type + "-" + resourceIdObject.id;
        if (data.meta) {
            return data.type + "-" + data.id + "-" + jsonStringify(data.meta) + "-" + resourcePart;
        }
        return data.type + "-" + data.id + "-" + resourcePart;
    };
    return DeserializeCache;
}());
exports.DeserializeCache = DeserializeCache;
//# sourceMappingURL=cache.js.map